export const presentSupportPersonName = value =>
  value ? String(value).toUpperCase() : '';

export const presentSupportAddress = row => {
  const main = [row?.logradouro, row?.numero].filter(Boolean).join(', ');
  const unit = [row?.unidade, row?.complemento].filter(Boolean).join(', ');

  return {
    main,
    detail: [unit, row?.bairro].filter(Boolean).join(' - '),
  };
};
